import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
// import ReactPaginate from 'react-paginate'
import Select from 'react-select'
import { ControlLabel, Form, FormGroup, FormControl, Row, Col, Button, Pagination, DropdownButton, MenuItem, Modal, InputGroup } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import HrStore from '../../../stores/HrStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import Moment from 'moment';

const localStorageKey = 'kkc.advanceSalary'
var NotificationSystem = require('react-notification-system');
class ReportAdvanceSalary extends Component {

  constructor(...args) {
    super(...args)

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const curMonth = parseInt(Moment().format('MM'))
    const curDay = parseInt(Moment().format('DD'))
    const all_day = Moment().daysInMonth()

    const optionsDay = []
    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }

    for (var i=0;i<=all_day;i++) {
      if (i > 0) {
        var label = i
        optionsDay.push({
          value: i,
          label: label
        })
      }
    }
    
    const optionsMonth = [
      { value: 1, label: 'มกราคม' },
      { value: 2, label: 'กุมภาพันธ์' },
      { value: 3, label: 'มีนาคม' },
      { value: 4, label: 'เมษายน' },
      { value: 5, label: 'พฤษภาคม' },
      { value: 6, label: 'มิถุนายน' },
      { value: 7, label: 'กรกฎาคม' },
      { value: 8, label: 'สิงหาคม' },
      { value: 9, label: 'กันยายน' },
      { value: 10, label: 'ตุลาคม' },
      { value: 11, label: 'พฤศจิกายน' },
      { value: 12, label: 'ธันวาคม' }
    ];

    const defaultPercent = JSON.parse(localStorage.getItem(localStorageKey)) || {percent:25,sortStatus:'',sortStatus2:'',sortStatus3:''}
    this.state = {
      loading:false,
      data:[],
      show:false,
      showExport:false,
      optionsYear: optionsYear, 
      optionsMonth: optionsMonth,
      optionsDay: optionsDay,
      defaultMonth: curMonth,
      defaultYear: yTh,
      defaultDay: curDay, // 0,
      defaultPercent: defaultPercent,
      percent: defaultPercent.percent,
      hideText: true
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    const optionsDay = []

    if (all_day) {
      for (var i=0;i<=all_day;i++) {
        if (i > 0) {
          var label = i
          optionsDay.push({
            value: i,
            label: label
          })
        }  
      }
      if (all_day<this.state.defaultDay) {
        var defaultDay = 1
      } else {
        var defaultDay = this.state.defaultDay
      }
    } else {
      optionsDay.push({
        value: 1,
        label: "1"
      })
      var defaultDay = 1
    }

    this.setState({ optionsDay: optionsDay, defaultDay:defaultDay })
    return defaultDay
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    let {defaultDay,defaultMonth,defaultYear} = this.state
    defaultYear = defaultYear - 543
    this.loadReportAdvanceSalary(defaultYear,defaultMonth,defaultDay)
  }

  loadReportAdvanceSalary(year='', month='', day='') {
    let that = this
    let {defaultPercent} = this.state
    this.setState({loading:true})
    HrStore.loadReportAdvanceSalary(year,month,day,function(result) {
      let data = result.data
      if (defaultPercent.sortStatus===''&&defaultPercent.sortStatus2===''&&defaultPercent.sortStatus3==='') {
        data = result.data
      } else {
        if (defaultPercent.sortStatus!=='') {
          if (defaultPercent.sortStatus===''||defaultPercent.sortStatus==='desc') {
            data.sort(function(a, b) {
              if(a.employee_id < b.employee_id) return -1;
              if(a.employee_id > b.employee_id) return 1;
              return 0;
            })
            data.reverse(function(a, b) {
              if(a.employee_id < b.employee_id) return -1;
              if(a.employee_id > b.employee_id) return 1;
              return 0;
            })
          } else if (defaultPercent.sortStatus==='asc') {
            data.sort(function(a, b) {
              if(a.employee_id < b.employee_id) return -1;
              if(a.employee_id > b.employee_id) return 1;
              return 0;
            })
          }
        } else if (defaultPercent.sortStatus2!=='') {
          if (defaultPercent.sortStatus2===''||defaultPercent.sortStatus2==='desc') {
            data.sort(function(a, b) {
              if(a.name < b.name) return -1;
              if(a.name > b.name) return 1;
              return 0;
            })
            data.reverse(function(a, b) {
              if(a.name < b.name) return -1;
              if(a.name > b.name) return 1;
              return 0;
            })
          } else if (defaultPercent.sortStatus2==='asc') {
            data.sort(function(a, b) {
              if(a.name < b.name) return -1;
              if(a.name > b.name) return 1;
              return 0;
            })
          }
        } else if (defaultPercent.sortStatus3!=='') {
          if (defaultPercent.sortStatus3===''||defaultPercent.sortStatus3==='desc') {
            data.sort(function(a, b) {
              if(a.nick_name < b.nick_name) return -1;
              if(a.nick_name > b.nick_name) return 1;
              return 0;
            })
            data.reverse(function(a, b) {
              if(a.nick_name < b.nick_name) return -1;
              if(a.nick_name > b.nick_name) return 1;
              return 0;
            })
          } else if (defaultPercent.sortStatus3==='asc') {
            data.sort(function(a, b) {
              if(a.nick_name < b.nick_name) return -1;
              if(a.nick_name > b.nick_name) return 1;
              return 0;
            })
          }
        }
      }
      that.setState({loading:false,data:data})
    })
  }  

  onYearChange(e) {
    var year = e.value - 543

    var date = year+"-"+this.state.defaultMonth
    let curDay = 0
    curDay = this.getAllDayOfMonth(date)

    this.setState({ defaultYear: e.value, activePage:1, defaultDay:curDay })
    this.loadReportAdvanceSalary(year, this.state.defaultMonth, curDay)
  }

  onMonthChange(e) {
    var date = this.state.defaultYear - 543+"-"+e.value
    let curDay = 0
    curDay = this.getAllDayOfMonth(date)

    this.setState({ defaultMonth: e.value, activePage:1, defaultDay:curDay })
    this.loadReportAdvanceSalary(this.state.defaultYear - 543, e.value, curDay)
  }

  onDayChange(e) {
    this.setState({ defaultDay: e.value })
    this.loadReportAdvanceSalary(this.state.defaultYear - 543, this.state.defaultMonth, e.value)
  }

  onTextChange(index,key,e) {
    let {data} = this.state
    if (key==='amount'&&e.target.value>this.getQuota(data[index]['salary'])) {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'เกินจำนวนที่สามารถเบิกได้',
        level: 'error',
        position: 'tc'
      })
      data[index][key] = 0
    } else {
      data[index][key] = e.target.value
    }  
    this.setState({data:data})
  }

  onNewClick() {
    let {data,defaultDay,defaultMonth,defaultYear} = this.state
    defaultYear = defaultYear - 543
    let that = this
    HrStore.newAdvanceSalary(defaultYear,defaultMonth,defaultDay,data,function(result) {
      console.log('result',result)
      if(result.status=='OK'){
        
        that.loadReportAdvanceSalary(defaultYear,defaultMonth,defaultDay)
      }
      that.refs.notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการสร้างตารางเรียบร้อย',
        level: 'info',
        position: 'tc'
      })
    })
  }

  onSettingSelect(key) {
    if(key==='1')
      this.setState({show:true})
  }

  // onModalClick() {
  //   this.setState({show:true})
  // }

  onExportClick() {
    let {hideText} = this.state
    this.setState({hideText:false,showExport:true})
  }

  onExportConfirmClick() {
    const worksheet = XLSX.utils.table_to_book(document.getElementById('table-report-advance-salary'));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), "การเบิกเงินล่วงหน้า.xlsx")
    this.setState({hideText:true,showExport:false})
  }

  onPercentChange(e) {
    let {percent} = this.state
    percent = e.target.value
    this.setState({percent:percent})
  }

  onPercentSave(e) {
    let {defaultPercent,percent} = this.state

    if (isNaN(percent)||percent===''||percent<0) {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'กรุณากรอกข้อมูลให้ถูกต้อง',
        level: 'error',
        position: 'tc'
      })
      this.setState({percent:defaultPercent.percent})
    } else {  
      let advanceSalaryConfig = {percent:percent,sortStatus:defaultPercent.sortStatus,sortStatus2:defaultPercent.sortStatus2,sortStatus3:defaultPercent.sortStatus3}
      localStorage.setItem(localStorageKey, JSON.stringify(advanceSalaryConfig))
      this.setState({defaultPercent:defaultPercent,show:false})
    }  
  }

  onSaveClick(){
    let {data} = this.state
    let that = this
    this.setState({loading:true})
    HrStore.saveAdvanceSalary(data,function(result){
      if(result.status==='OK'){
        that._notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: 'บันทึกข้อมูลเข้าระบบรายรับของพนักงานเรียบร้อย',
          level: 'info',
          position: 'tc'
        })
        that.setState({loading:false,data:result.data})
      }else{
        that._notificationSystem.addNotification({
          title: 'แจ้งเตือน',
          message: 'บันทึกข้อมูลเข้าระบบมีปัญหา โปรดลองอีกครั้ง',
          level: 'error',
          position: 'tc'
        })
        that.setState({loading:false})
      }
      
    },function(){
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'บันทึกข้อมูลเข้าระบบมีปัญหา โปรดลองอีกครั้ง',
        level: 'error',
        position: 'tc'
      })
      that.setState({loading:false})
    })
  }

  onEmployeeClick(emId){    
    if (process.env.NODE_ENV == "development") {
      alert('click->'+emId)
    }else{
      if(window.show_employee_doc!==undefined)
        window.show_employee_doc(emId);
    }
  }

  getQuota(value) {
    let defaultPercent = JSON.parse(localStorage.getItem(localStorageKey))
    if (defaultPercent===null||defaultPercent===undefined)
      defaultPercent = {percent:25}

    return (value*defaultPercent.percent) / 100
  }

  renderRowData() {
    let {data,hideText} = this.state
    if (data===undefined||data.length===0) {
      return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index) => {
          return(
            <tr key={index}>
              <td className='text-center' onClick={this.onEmployeeClick.bind(this,item.employee_id)}>{item.employee_id}{' '}<FontAwesome name='id-card'/></td>
              <td>{item.name}</td>
              <td className='text-center'>{item.nick_name}</td>
              <td className='text-right'>{item.salary}</td>
              <td className='text-right'>{this.getQuota(item.salary)}</td>
              <td className='text-right'>
                <FormControl style={{display:hideText?'':'none'}} className='text-right' value={item.amount} onChange={this.onTextChange.bind(this,index,'amount')} />
                <span style={{display:!hideText?'':'none'}}>{item.amount}</span>
              </td>
              <td>
                <FormControl style={{display:hideText?'':'none'}} className='text-left' value={item.remark} onChange={this.onTextChange.bind(this,index,'remark')} />
                <span style={{display:!hideText?'':'none'}}>{item.remark}</span>
              </td>
            </tr>
          )
        })
      )
    }
  }

  onSortClick(key,e) {
    let {data,defaultPercent,percent} = this.state
    if (data!==undefined&&data.length>1) {
      if (key==='code') { 
        if (defaultPercent.sortStatus===''||defaultPercent.sortStatus==='desc') {
          defaultPercent.sortStatus = 'asc'
          data.sort(function(a, b) {
            if(a.employee_id < b.employee_id) return -1;
            if(a.employee_id > b.employee_id) return 1;
            return 0;
          })
        } else if (defaultPercent.sortStatus==='asc') {
          defaultPercent.sortStatus = 'desc'
          data.reverse(function(a, b) {
            if(a.employee_id < b.employee_id) return -1;
            if(a.employee_id > b.employee_id) return 1;
            return 0;
          })
        }
        defaultPercent.sortStatus2 = ''
        defaultPercent.sortStatus3 = ''
      } else if (key==='name') { 
        if (defaultPercent.sortStatus2===''||defaultPercent.sortStatus2==='desc') {
          defaultPercent.sortStatus2 = 'asc'
          data.sort(function(a, b) {
            if(a.name < b.name) return -1;
            if(a.name > b.name) return 1;
            return 0;
          })
        } else if (defaultPercent.sortStatus2==='asc') {
          defaultPercent.sortStatus2 = 'desc'
          data.reverse(function(a, b) {
            if(a.name < b.name) return -1;
            if(a.name > b.name) return 1;
            return 0;
          })
        }
        defaultPercent.sortStatus = ''
        defaultPercent.sortStatus3 = ''
      } else if (key==='nick_name') { 
        if (defaultPercent.sortStatus3===''||defaultPercent.sortStatus3==='desc') {
          defaultPercent.sortStatus3 = 'asc'
          data.sort(function(a, b) {
            if(a.nick_name < b.nick_name) return -1;
            if(a.nick_name > b.nick_name) return 1;
            return 0;
          })
        } else if (defaultPercent.sortStatus3==='asc') {
          defaultPercent.sortStatus3 = 'desc'
          data.reverse(function(a, b) {
            if(a.nick_name < b.nick_name) return -1;
            if(a.nick_name > b.nick_name) return 1;
            return 0;
          })
        }
        defaultPercent.sortStatus = ''
        defaultPercent.sortStatus2 = ''
      }
      let config = {percent:percent,sortStatus:defaultPercent.sortStatus,sortStatus2:defaultPercent.sortStatus2,sortStatus3:defaultPercent.sortStatus3}
      localStorage.setItem(localStorageKey, JSON.stringify(config))
      this.setState({data:data,defaultPercent:defaultPercent})
    }  
  }

  renderTable() {
    let {defaultPercent} = this.state
    return(
      <div className='table-responsive'>
        <table id='table-report-advance-salary' className='table table-hover table-bordered-solid'>
          <thead>
            <tr>
              <th onClick={this.onSortClick.bind(this,'code')} className='text-center' style={{width:'150px'}}>รหัสพนักงาน&nbsp;<FontAwesome className={'pull-right'} name={(defaultPercent.sortStatus===''?'sort':defaultPercent.sortStatus==='asc'?'sort-asc':defaultPercent.sortStatus==='desc'?'sort-desc':'sort')} /></th>
              <th onClick={this.onSortClick.bind(this,'name')} className='text-center' style={{width:'300px'}}>ชื่อนามสกุล&nbsp;<FontAwesome className={'pull-right'} name={(defaultPercent.sortStatus2===''?'sort':defaultPercent.sortStatus2==='asc'?'sort-asc':defaultPercent.sortStatus2==='desc'?'sort-desc':'sort')} /></th>
              <th onClick={this.onSortClick.bind(this,'nick_name')} className='text-center' style={{width:'100px'}}>ชื่อเล่น&nbsp;<FontAwesome className={'pull-right'} name={(defaultPercent.sortStatus3===''?'sort':defaultPercent.sortStatus3==='asc'?'sort-asc':defaultPercent.sortStatus3==='desc'?'sort-desc':'sort')} /></th>
              <th className='text-center' style={{width:'100px'}}>เงินเดือน</th>
              <th className='text-center' style={{width:'120px'}}>เบิกได้ (บาท)</th>
              <th className='text-center' style={{width:'120px'}}>เบิกจริง (บาท)</th>
              <th className='text-center' >หมายเหตุ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th className='text-center'>รหัสพนักงาน</th>
              <th className='text-center'>ชื่อนามสกุล</th>
              <th className='text-center'>ชื่อเล่น</th>
              <th className='text-center'>เงินเดือน</th>
              <th className='text-center'>เบิกได้ (บาท)</th>
              <th className='text-center'>เบิกจริง (บาท)</th>
              <th className='text-center'>หมายเหตุ</th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  renderHeader() {
    let {show} = this.state
    return(
          <Form inline>
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultYear }
                options={this.state.optionsYear}
                style={{ width: "80px" }}
                onChange={ this.onYearChange.bind(this) }
              />
            </FormGroup>
            <FormGroup style={{marginLeft:'5px'}}>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultMonth }
                options={this.state.optionsMonth}
                style={{ width: "120px" }}
                onChange={ this.onMonthChange.bind(this) }
              />
            </FormGroup>
            <FormGroup style={{marginLeft:'5px'}}>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultDay }
                style={{ width: "80px" }}
                options={this.state.optionsDay}
                onChange={this.onDayChange.bind(this)}
              />
            </FormGroup>
            <FormGroup style={{marginLeft:'5px'}}>
              <Button className='btn btn-primary' onClick={this.onNewClick.bind(this)}><FontAwesome name='table' />&nbsp;สร้างตาราง</Button>
            </FormGroup>
            <FormGroup style={{marginLeft:'5px'}}>
              <Button className='btn btn-success' onClick={this.onExportClick.bind(this)}><FontAwesome name='file-excel-o' />&nbsp;ออกไฟล์ Excel</Button>
            </FormGroup>
          </Form> 
    )
  }

  renderModalSetting() {
    let {show,defaultPercent,percent} = this.state
    return(
          <div>
            <Modal show={show} onHide={()=>this.setState({show:false})}>
              <Modal.Header closeButton>
                <Modal.Title>การเบิกเงินล่วงหน้า</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <ControlLabel>เบิกเงินล่วงหน้า</ControlLabel>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <InputGroup>
                          <FormControl type='text' value={percent} onChange={this.onPercentChange.bind(this)} />
                          <InputGroup.Addon>%</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button className='btn btn-primary' onClick={this.onPercentSave.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>
                <Button className='btn' onClick={()=>this.setState({show:false})}><FontAwesome name='close' />&nbsp;ปิด</Button>
              </Modal.Footer>
            </Modal>
          </div>
    )
  }

  renderModalExport() {
    let {showExport} = this.state
    return(
          <div>
            <Modal show={showExport} onHide={()=>this.setState({showExport:false,hideText:true})}>
              <Modal.Header closeButton>
                <Modal.Title>ยืนยันดาวน์โหลดไฟล์ Excel</Modal.Title>
              </Modal.Header>
              <Modal.Footer>
                <Button className='btn btn-primary' onClick={this.onExportConfirmClick.bind(this)}><FontAwesome name='thumbs-o-up' />&nbsp;ยืนยัน</Button>
                <Button className='btn' onClick={()=>this.setState({showExport:false,hideText:true})}><FontAwesome name='close' />&nbsp;ปิด</Button>
              </Modal.Footer>
            </Modal>
          </div>
    )
  }

  render() {
    let {show,defaultPercent,percent} = this.state
    let title = (<span><FontAwesome name='cogs'/>{' '}ตั้งค่า</span>)
    return (
      <Box loading={this.state.loading}>
        <Box.Header>
          <Box.Title>
            <FontAwesome name='history' className='color-blue' />&nbsp;ตารางการเบิกเงินล่วงหน้า
          </Box.Title>
          <Box.Tools>
            <DropdownButton bsStyle={'link'} title={title} pullRight id="split-button-pull-right" className='text-large' onSelect={this.onSettingSelect.bind(this)}>
              <MenuItem eventKey="1">ตั้งค่าการเบิกเงินล่วงหน้า</MenuItem>
            </DropdownButton>
          </Box.Tools>
        </Box.Header>
        <Box.Body>
          {this.renderHeader()}
          <br/>
          {this.renderTable()}
          {this.renderModalSetting()}
          {this.renderModalExport()}
          <NotificationSystem ref="notificationSystem" /> 
        </Box.Body>
        <Box.Footer>
          <div className='pull-right'>
            <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save'/>{' '} บันทึกข้อมูล</Button>
          </div>
        </Box.Footer>
      </Box>
    )
  }
}

export default ReportAdvanceSalary;


// WEBPACK FOOTER //
// ./src/view/hr/report/ReportAdvanceSalary.js